module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="settings">\r\n    <h2>Settings list</h2>\r\n    <div class="list-group">\r\n        <a href="#persons" class="list-group-item"><b>Persons</b></a>\r\n        <a href="#import-persons" class="list-group-item"><b>Persons import</b></a>\r\n        <a href="#merge-persons" class="list-group-item"><b>Persons merge</b></a>\r\n        <a href="#relations" class="list-group-item hidden"><b>Relations</b></a>\r\n        <a href="#relationtypes" class="list-group-item hidden"><b>Relation types</b></a>\r\n        <a href="#roles" class="list-group-item"><b>Roles (permissions templates)</b></a>\r\n        <a href="#doctypes" class="list-group-item"><b>Document types</b></a>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/settings/settings.html
// module id = 425
// module chunks = 0